import { Lead } from "../lead/lead.js";
const lead = new Lead();
window.lead = lead;

// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

document.addEventListener('DOMContentLoaded', () => {
	const menuBtn = document.querySelector('.header-main__info-burger');
	const menu = document.querySelector('.header-main__info-block');
	const header = document.querySelector('.header-main');

	if (!menuBtn || !menu || !header) return;

	menuBtn.addEventListener('click', function () {
		const headerHeight = header.offsetHeight + 'px';
		menu.style.setProperty('--header-offset', headerHeight);

		menuBtn.classList.toggle('active');
		menu.classList.toggle('active');
	});
});


$(document).ready(function() {
	// Открытие попапа
	$('.header-main-info-social, .header-main-info-social-burger').on('click', function() {
	  $('#feedbackPopup').addClass('active');
	});
  
	// Закрытие попапа
	$('#closePopup').on('click', function() {
	  $('#feedbackPopup').removeClass('active');
	});
  
	// Закрытие при клике вне попапа
	$('#feedbackPopup').on('click', function(e) {
	  if (e.target === this) {
		$(this).removeClass('active');
	  }
	});
  
	  // Простейшая обработка телефона
	  $('input[type="tel"]')
	  .on('focus', function() {
		if ($(this).val() === '') {
		  $(this).val('+7 ');
		  this.setSelectionRange(3, 3);
		}
	  })
	  .on('keydown', function(e) {
		// Запрещаем изменение "+7"
		if (this.selectionStart < 3 && 
			!['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
		  e.preventDefault();
		}
		
		// Разрешаем только цифры и управляющие клавиши
		if (!/\d/.test(e.key) && 
			!['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
		  e.preventDefault();
		}
	  });
  
	// Отправка формы
	$('.popup-form').on('submit', function(e) {
	  e.preventDefault();
	  // Здесь код для отправки формы
	  $('#feedbackPopup').removeClass('active');
	  alert('Форма отправлена!');
	});
});

//SWIPER
$(document).ready(function () {
	var swiper = new Swiper(".preview-swiper", {
		slidesPerView: 1,
		// centeredSlides: false,
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
		navigation: {
			nextEl: ".preview-btn-next",
			prevEl: ".preview-btn-prev",
		},
	});
});

$(document).ready(function () {
	var swiper = new Swiper(".banner-swiper", {
		slidesPerView: 1,
		// centeredSlides: false,
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
		navigation: {
			nextEl: ".banner-btn-next",
			prevEl: ".banner-btn-prev",
		},
	});
});

$(document).ready(function () {
	var swiper = new Swiper(".partners-swiper", {
		slidesPerView: 2.5,
		spaceBetween: 30,
		// centeredSlides: false,
		pagination: {
			el: ".partners-pagination",
			type: "fraction",
		},
		navigation: {
			nextEl: ".partners-btn-next",
			prevEl: ".partners-btn-prev",
		},
		breakpoints: {
			480: {
				slidesPerView: 3.5,
			},
			600: {
				slidesPerView: 4.5,
			},
			768: {
				slidesPerView: 5.5,
			},
			1024: {
				slidesPerView: 6.5,
			},
			1280: {
				slidesPerView: 7,
			},
		},
	});
});

$(document).ready(function () {
	var swiper = new Swiper(".project-swiper", {
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		pagination: {
			el: ".project-pagination",
			type: "fraction",
		},
		navigation: {
			nextEl: ".project-btn-next",
			prevEl: ".project-btn-prev",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	});
});

//HEADER
function updateUnderline() {
	const active = document.querySelector('.header-main__info-block-item.active')
	const header = document.querySelector('.header-main')

	if (!active || !header) return

	const itemRect = active.getBoundingClientRect()
	const headerRect = header.getBoundingClientRect()

	const width = itemRect.width
	const left = itemRect.left - headerRect.left

	header.style.setProperty('--underline-width', `${width}px`)
	header.style.setProperty('--underline-x', `${left}px`)

	// напрямую, если не через переменные
	header.style.setProperty('--underline-transform', `translateX(${left}px)`)
	header.style.setProperty('--underline-w', `${width}px`)
	header.style.width = '' // если случайно фиксировали
}

// клик по пункту меню
document.querySelectorAll('.header-main__info-block-item a').forEach(link => {
	link.addEventListener('click', e => {
		document.querySelectorAll('.header-main__info-block-item').forEach(i =>
			i.classList.remove('active')
		)

		const li = link.closest('.header-main__info-block-item')
		li.classList.add('active')

		updateUnderline()
	})
})

// при загрузке и ресайзе тоже
window.addEventListener('load', updateUnderline)
window.addEventListener('resize', updateUnderline)


//COPY
$(document).ready(function() {
  // Копирование email
  $('.copy-email-btn').on('click', function(e) {
    e.preventDefault();
    
    const email = $(this).closest('li').find('.email-to-copy').text().trim();
    
    // Создаем временный элемент для копирования
    const $temp = $('<textarea>');
    $('body').append($temp);
    $temp.val(email).select();
    
    try {
      document.execCommand('copy');
      showTooltip($(this), 'Скопировано!');
    } catch (err) {
      showTooltip($(this), 'Ошибка копирования');
      console.error('Ошибка при копировании:', err);
    }
    
    $temp.remove();
  });

  // Функция для показа уведомления (вместо alert)
  function showTooltip($element, message) {
    const tooltip = $('<div class="copy-tooltip">').text(message);
    $element.after(tooltip);
    
    setTimeout(function() {
      tooltip.fadeOut(200, function() {
        $(this).remove();
      });
    }, 1500);
  }
});